<template>
  <v-row dense>
    <v-col cols="12">
      <v-card tile color="primary" class="elevation-0 mb-2">
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
          @click="cheatCode"
        >
          {{ title }}
        </v-card-title>
        <v-card-subtitle
          class="pb-2"
          @click="cheatCode"
        >
          {{ subtitle }}
        </v-card-subtitle>
      </v-card>
      <v-card
        tile
        class="mt-3"
      >
        <v-data-table
          :headers="headers"
          :items="accessLogs"
          :options.sync="options"
          :server-items-length="totalAccessLogs"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50, -1],
          }"
          :loading="loading"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <!-- <v-toolbar-title>Logs de Accesos</v-toolbar-title> -->
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="mr-2"
                @click="showSearchModal = !showSearchModal"
                :color="isFiltered ? 'orange' : 'grey'"
              >
                <v-icon v-if="isFiltered">mdi-filter-remove-outline</v-icon>
                <v-icon v-else>mdi-filter-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="2 === 3"
                color="primary"
                class="mr-2"
                small
                @click="openAnalysisModal"
              >
                Analizar datos filtrados
              </v-btn>
              <v-switch
                v-model="autoRefresh"
                label="Auto refresh"
                class="mt-4"
              ></v-switch>
            </v-toolbar>
          </template>
          <template v-slot:[`item.door`]="{ item }">
            <v-list-item>
              <v-list-item-content>
                <div v-if="item && item.door && item.door.zone" class="text-caption">
                  {{ item.door.zone.name }}
                </div>
                <v-list-item-title
                  v-if="item && item.door"
                >
                  {{ item.door.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:[`item.person`]="{ item }">
            <v-list-item dense>
              <v-list-item-avatar
                size="55"
                color="grey"
                tile
                @click="showPreviewImage(item.person.picture.image)"
              >
                <v-img
                  :src="item.person.picture.image"
                  :alt="item.person.name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <div>
                  {{ item.person.name }} {{ item.person.last_name }}
                </div>
                <v-list-item-title>
                  {{ item.person.company ? item.person.company.name : 'N/A' }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.person.document_number }}
                  <v-btn
                    v-if="item.person.document_number !== '00000000000'"
                    icon
                    x-small
                    @click="letsShowPersonModal(item.person.id, item.door.id)"
                  >
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:[`item.permission_time_type`]="{ item }">
            <v-icon
              x-small
              :color="getPermissionTimeTypeColor(item.permission_time_type)"
            >
              mdi-circle
            </v-icon>
            <span>
              {{ getPermissionTimeTypeText(item.permission_time_type) }}
            </span>
          </template>
          <template v-slot:[`item.recognition_mode`]="{ item }">
            <!-- <v-icon
              x-small
              color="primary"
              class="mr-1"
            >
              {{ getRecognitionModeIcon(item.recognition_mode) }}
            </v-icon> -->
            <span>
              {{ getRecognitionModeText(item.recognition_mode) }}
            </span>
          </template>
          <template v-slot:[`item.profile`]="{ item }">
            <JimProfile
              v-if="item.person.document_number === '00000000000'"
              :value="item.person"
              :image-url="item.verification_shot_url"
              :controllerId="item.door.id"
              @identifyPerson="identifyPerson"
            />
          </template>
          <template v-slot:[`item.verification_shot_url`]="{ item }">
            <v-avatar
              size="55"
              tile
              @click="showPreviewImage(item.verification_shot_url)"
            >
              <v-img
                :src="item.verification_shot_url"
                :alt="item.person.name"
              />
            </v-avatar>
          </template>
          <template v-slot:[`item.access_time`]="{ item }">
            {{ item.access_time|datetime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <IdentifyComponent
      v-model="showPreviewModal"
      :image-url="currentImageUrl"
      :show-identify-btn="show_detailed_stranges"
    />
    <v-dialog
      v-model="showSearchModal"
      width="450"
    >
      <v-card>
        <v-card-title
          class="font-weight-medium grey--text px-3"
        >
          Filtrar Logs de Acceso
        </v-card-title>
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="form.person__name"
                label="Nombre"
                hide-details
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.person__document_number"
                label="Numero de documento"
                hide-details
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col>
              <date-component
                v-model="form.access_date"
                label="Fecha"
              ></date-component>
            </v-col>
            <v-col
              cols="12"
            >
              <v-autocomplete
                v-model="form.person__company__id"
                :items="companies"
                label="Empresa"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="form.with_company_only"
                label="Con empresa identificada"
                hide-details
                dense
              >
                <!--  -->
              </v-checkbox>
            </v-col>
            <v-col
              cols="12"
            >
              <v-select
                v-model="form.access_type"
                :items="accessTypes"
                label="Tipo de acceso"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
                clearable
              >
                <!--  -->
              </v-select>
            </v-col>
            <v-col
              cols="6"
            >
              <v-select
                v-model="form.door__id"
                :items="controllers"
                label="Nombre de puerta"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
                clearable
                multiple
              >
                <!--  -->
              </v-select>
            </v-col>
            <v-col
              cols="6"
            >
              <v-select
                v-model="form.door__zone__id"
                :items="zones"
                label="Nombre de zona"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
                multiple
                clearable
              >
                <!--  -->
              </v-select>
            </v-col>
            <v-col
              cols="12"
            >
              <v-select
                v-model="form.permission_time_type"
                :items="permissionTimeTypes"
                label="Vigencia del permiso"
                item-text="name"
                item-value="id"
                hide-details
                dense
                outlined
                clearable
              >
                <template v-slot:selection="{ item }">
                  {{ $t(item.name) }}
                </template>
                <template v-slot:item="{ item }">
                  {{ $t(item.name) }}
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-right"
            >
              <v-btn
                text
                color="grey"
                @click="showSearchModal = false"
              >
                Cerrar
              </v-btn>
              <v-btn
                color="success"
                @click="showSearchModal = false"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <PersonModal
      v-if="showPersonModal"
      v-model="showPersonModal"
      :personId="personId"
      :controllerId="controllerId"
    />
    <LogAnalysisModal
      v-if="showAnalysisModal"
      v-model="showAnalysisModal"
    />
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';
import DateComponent from '@/components/DateComponent';
import IdentifyComponent from '@/components/IdentifyComponent';
import JimProfile from '@/components/JimProfile';
import PersonModal from '@/components/PersonModal';
import LogAnalysisModal from '@/components/LogAnalysisModal';
import _ from 'lodash';

export default {
  components: {
    DateComponent,
    IdentifyComponent,
    JimProfile,
    PersonModal,
    LogAnalysisModal,
  },

  data() {
    return {
      title: 'Logs de Acceso',
      subtitle: 'Logs accesos reconocimiento facial',
      loading: true,
      form: {
        person__name: null,
        person__document_number: null,
        access_date: null,
        person__company__id: null,
        with_company_only: false,
        access_type: null,
        door__id: null,
        door__zone__id: null,
        permission_time_type: null,
      },
      options: {},
      showPreviewModal: false,
      currentImageUrl: '',
      showSearchModal: false,
      autoRefresh: false,
      seachInterval: null,
      currentCheatCode: '',
      showPersonModal: false,
      personId: null,
      controllerId: null,
      showAnalysisModal: false,
    };
  },

  computed: {
    ...mapState(
      `${types.ACCESS_LOGS}`, [
        'accessLogs',
        'totalAccessLogs',
        'permissionTimeTypes',
        'accessTypes',
      ],
    ),
    ...mapState(
      `${types.COMPANY}`, [
        'companies',
      ],
    ),
    ...mapState(
      `${types.CONTROLLER}`, [
        'controllers',
      ],
    ),
    ...mapState(
      `${types.ZONE}`, [
        'zones',
      ],
    ),
    headers() {
      const baseHeaders = [
        { text: 'Puerta', value: 'door' },
        { text: 'Tipo', value: 'access_type' },
        { text: 'Persona', value: 'person' },
        { text: 'Modo Verificación', value: 'recognition_mode' },
        { text: 'Vigencia del Permiso', value: 'permission_time_type' },
        { text: 'Shot', value: 'verification_shot_url' },
        { text: 'Hora', value: 'access_time' },
      ];

      if (this.show_detailed_stranges) {
        baseHeaders.splice(5, 0, { text: 'Perfil', value: 'profile' });
      }

      return baseHeaders;
    },
    params() {
      return {
        skip: (this.options.page - 1) * this.options.itemsPerPage,
        limit: this.options.itemsPerPage > 1 ? this.options.itemsPerPage : this.totalAccessLogs,
        ...this.form,
        sort_by: this.options.sortBy,
        desc: this.options.sortDesc,
      };
    },
    isFiltered() {
      return Object.values(this.form).some(
        (value) => value !== null && value !== false && value !== undefined && value !== '',
      );
    },
    show_detailed_stranges() {
      return this.currentCheatCode === `${this.title}${this.title}${this.subtitle}`;
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
    }),
    ...mapActions({
      [types.GET_ACCESS_LOGS]: `${types.ACCESS_LOGS}/${types.GET_ACCESS_LOGS}`,
    }),
    getPermissionTimeTypeColor(permissionTimeType) {
      if (!permissionTimeType) return 'red';

      const { id, reason } = permissionTimeType;

      if (id === '1') return 'green';
      if (id === '2' && reason && reason !== 'Out of time restriction') return 'warning';
      return 'red';
    },
    getPermissionTimeTypeText(permissionTimeType) {
      if (!permissionTimeType) return this.$t('Not judged');

      if (permissionTimeType.reason) {
        // Handle "Out of time restriction" direct translation
        if (permissionTimeType.reason === 'Out of time restriction') {
          return this.$t('Out of time restriction');
        }

        // Handle penalty pattern with hours extraction
        const penaltyMatch = permissionTimeType.reason.match(/Access restricted due to penalty \(([0-9.]+) hours remaining\)/);
        if (penaltyMatch) {
          const hours = penaltyMatch[1];
          return this.$t('Access restricted due to penalty ({hours} hours remaining)', { hours });
        }

        // Return raw reason for any other patterns
        return permissionTimeType.reason;
      }

      return this.$t(permissionTimeType.description);
    },
    getRecognitionModeIcon(recognitionMode) {
      if (!recognitionMode) return 'mdi-help-circle';

      if (recognitionMode === 'Card verification') {
        return 'mdi-credit-card';
      }
      if (recognitionMode === 'Face recognition') {
        return 'mdi-face-recognition';
      }

      return 'mdi-help-circle';
    },
    getRecognitionModeText(recognitionMode) {
      if (!recognitionMode) return 'N/A';

      return this.$t(recognitionMode);
    },
    getAccessLogs(params) {
      this.loading = true;
      this[types.GET_ACCESS_LOGS](params)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    populateFormFromQuery() {
      const { query } = this.$route;

      // Loop through the query keys and update the matching form fields
      Object.keys(query).forEach((key) => {
        if (key in this.form) {
          let value = query[key];

          if (value === 'true') {
            value = true;
          } else if (value === 'false') {
            value = false;
          }

          this.form[key] = value;
        }
      });
    },
    showPreviewImage(imageUrl) {
      this.currentImageUrl = imageUrl;
      this.showPreviewModal = true;
    },
    cheatCode(event) {
      this.currentCheatCode += event.target.innerText;
    },
    letsShowPersonModal(personId, controllerId) {
      this.personId = personId;
      this.controllerId = controllerId;
      this.showPersonModal = true;
    },
    ...mapActions({
      [types.GET_COMPANIES]: `${types.COMPANY}/${types.GET_COMPANIES}`,
    }),
    openAnalysisModal() {
      this.showAnalysisModal = true;
    },
    identifyPerson(personId, controllerId) {
      this.letsShowPersonModal(personId, controllerId);
    },
    ...mapActions({
      [types.GET_CONTROLLERS]: `${types.CONTROLLER}/${types.GET_CONTROLLERS}`,
    }),
    ...mapActions({
      [types.GET_ZONES]: `${types.ZONE}/${types.GET_ZONES}`,
    }),
  },

  watch: {
    params: {
      handler(params) {
        this.$router.replace({ query: params })
          .catch(() => {});
      },
      deep: true,
    },
    '$route.query': {
      handler(params) {
        this.debouncedGetAccessLogs(params);
      },
      deep: true,
    },
    autoRefresh(value) {
      if (value) {
        this.seachInterval = setInterval(() => {
          this.getAccessLogs(this.$route.query);
        }, 10 * 1000);
      } else {
        clearInterval(this.seachInterval);
      }
    },
  },

  created() {
    this.debouncedGetAccessLogs = _.debounce(this.getAccessLogs, 500);
  },

  mounted() {
    this.populateFormFromQuery();

    // Auto refresh on, for kiosk mode, need to refact.
    setTimeout(() => {
      if (!this.isFiltered) {
        this.autoRefresh = true;
      }
    }, 2000);

    this[types.GET_COMPANIES]()
      .then(() => {})
      .catch(() => {});

    this[types.GET_CONTROLLERS]()
      .then(() => {})
      .catch(() => {});

    this[types.GET_ZONES]()
      .then(() => {})
      .catch(() => {});
  },

  destroyed() {
    clearInterval(this.seachInterval);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access-logs/AccessLogList.vue